(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('clearhouse-media-gallery')) {
    customElements.define('clearhouse-media-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.galleryReady) return;
        this.galleryReady = true;
        this.track = this.querySelector('[data-gallery-track]');
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        this.previous = this.querySelector('[data-gallery-previous]');
        this.next = this.querySelector('[data-gallery-next]');
        this.modal = this.querySelector('[data-gallery-modal]');
        this.current = 0;
        const controls = this.querySelector('[data-gallery-controls]');
        if (controls) controls.hidden = false;
        this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', event => {
          event.preventDefault();
          this.select(index);
        }));
        this.previous?.addEventListener('click', () => this.select(this.current - 1));
        this.next?.addEventListener('click', () => this.select(this.current + 1));
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const direction = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
          if (direction) {
            event.preventDefault();
            this.select(this.current + direction);
          }
        });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            const width = this.track.clientWidth;
            if (width) this.update(Math.round(this.track.scrollLeft / width));
          });
        }, { passive: true });
        this.querySelectorAll('[data-gallery-open]').forEach(link => link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !this.modal.showModal) return;
          event.preventDefault();
          const fullImage = link.querySelector('img').cloneNode(false);
          fullImage.removeAttribute('srcset');
          fullImage.removeAttribute('sizes');
          fullImage.removeAttribute('class');
          fullImage.removeAttribute('fetchpriority');
          fullImage.src = link.href;
          fullImage.loading = 'eager';
          this.querySelector('[data-gallery-modal-image]').replaceChildren(fullImage);
          this.modal.showModal();
          document.documentElement.classList.add('ch-gallery-zoom-open');
        }));
        this.querySelector('[data-gallery-close]').addEventListener('click', () => this.modal.close());
        this.modal.addEventListener('click', event => {
          if (event.target === this.modal) this.modal.close();
        });
        this.modal.addEventListener('close', () => document.documentElement.classList.remove('ch-gallery-zoom-open'));
        this.update(0);
      }
      select(index) {
        index = Math.min(Math.max(index, 0), this.slides.length - 1);
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior });
        this.update(index);
      }
      update(index) {
        if (!this.slides.length) return;
        this.current = Math.min(Math.max(index, 0), this.slides.length - 1);
        this.thumbs.forEach((thumb, i) => {
          if (i === this.current) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        if (this.previous) this.previous.disabled = this.current === 0;
        if (this.next) this.next.disabled = this.current === this.slides.length - 1;
        const count = this.querySelector('[data-gallery-count]');
        const title = this.querySelector('[data-gallery-title]:not([data-gallery-slide])');
        if (count) count.textContent = String(this.current + 1);
        if (title) title.textContent = this.slides[this.current].dataset.galleryTitle;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["replacement-pack"] && !Shopify.designMode) return;
  try {
    function bindReplacementPacks(root = document) {
 root.querySelectorAll('[data-replacement-pack]').forEach(pack => {
  if (pack.dataset.bound) return;
  pack.dataset.bound = 'true';
  const form = pack.querySelector('#replacement-pack-form');
  const plans = pack.querySelectorAll('[data-pack-plan]');
  function updatePlan() {
   const selected = pack.querySelector('[data-pack-plan]:checked');
   if (!selected) return;
   pack.querySelector('[data-pack-price]').textContent = selected.dataset.planPrice;
   pack.querySelector('[data-pack-price-unit]').textContent = selected.dataset.priceUnit;
   const terms = pack.querySelector('[data-pack-terms]');
   if (terms) terms.hidden = selected.dataset.recurring !== 'true';
   const installments = pack.querySelector('[data-pack-installments]');
   if (installments) installments.hidden = selected.dataset.recurring === 'true';
  }
  plans.forEach(plan => plan.addEventListener('change', updatePlan));
  updatePlan();
  form?.addEventListener('submit', event => {
   const button = form.querySelector('[data-pack-add]');
   if (pack.dataset.purchasesEnabled !== 'true' || !button || button.disabled || (plans.length && !pack.querySelector('[data-pack-plan]:checked'))) event.preventDefault();
  });
 });
}
bindReplacementPacks();
document.addEventListener('shopify:section:load', event => bindReplacementPacks(event.target));
  } catch(e) { console.error(e); }
})();

})();
